import { Star } from "@phosphor-icons/react";
import useReveal from "./useReveal";
import "./home.css";
import "./HomeStats.css";

/*
 * Social-proof strip under the hero video. The 4.9 / 650 numbers mirror the
 * SoftwareApplication aggregateRating in public/index.html — keep in sync.
 */

const STATS = [
  { value: "650", prefix: "+", label: "מטפלים מנהלים איתנו את הקליניקה" },
  { value: "4.9", suffix: "/5", label: "דירוג ממוצע ממשתמשי המערכת", stars: true },
  { value: "30", suffix: " יום", label: "ניסיון חינם, ללא כרטיס אשראי" },
];

function HomeStats() {
  const ref = useReveal();

  return (
    <section className="hstats" aria-label="נתוני המערכת">
      <div className="home-container">
        <div className="hstats-grid home-reveal" ref={ref}>
          {STATS.map((stat) => (
            <div className="hstats-item" key={stat.label}>
              <span className="hstats-value">
                {stat.stars && <Star size={20} weight="fill" className="hstats-star" aria-hidden="true" />}
                <span dir="ltr">
                  {stat.prefix}
                  {stat.value}
                </span>
                {stat.suffix && <span className="hstats-suffix">{stat.suffix}</span>}
              </span>
              <span className="hstats-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeStats;
